import React from 'react'
import type { ProductGalleryQueryQuery } from '@generated/graphql'
import { JsonLd } from 'gatsby-plugin-next-seo'

type ProductGalleryJsonLdProps = {
  title: string
  base: string
  description?: string
  products?: ProductGalleryQueryQuery['search']['products']['edges']
}

type SearchResultsPageJsonLd = {
  '@type': 'SearchResultsPage'
}

export const ProductGalleryJsonLd = ({
  title,
  base,
  description = '',
  products,
}: ProductGalleryJsonLdProps) => {
  const isSearchPage = base === '/s/'

  if (!products) {
    return <></>
  }

  const mainEntity: SearchResultsPageJsonLd | undefined = isSearchPage
    ? {
        '@type': 'SearchResultsPage',
      }
    : undefined

  return (
    <JsonLd
      json={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        url: window.location.href,
        name: isSearchPage ? 'Resultados da Pesquisa' : title,
        description: isSearchPage
          ? 'Resultados para a consulta de pesquisa'
          : description,
        mainEntity,
      }}
    />
  )
}
